import ToastComponent from './toast.vue'

export default {
  install (Vue: any) {
    const ToastConstructor = Vue.extend(ToastComponent)
    const instance = new ToastConstructor()

    instance.$mount(document.createElement('div'))
    document.body.appendChild(instance.$el)

    Vue.prototype.$toast = (msg: string, duration: number = 1500) => {
      if (instance.visible) return

      instance.message = msg
      instance.visible = true

      window.setTimeout(() => {
        instance.visible = false
      }, duration)
    }
  }
}
